import { getEloToggleByCountryMyProfile } from './getEloToggleMyProfile'
import { getEloToggleByCountryByRegisters } from './getEloToggleRegisters'

export const getEloToggleByCountry = () => {
    return getEloToggleByCountryByRegisters() || getEloToggleByCountryMyProfile()
}
